import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { Navbar, Nav, Badge } from "react-bootstrap";
import { Auth } from "aws-amplify";
import CompanyLocationSelector from '../common/CompanyLocationSelector';
import { HTTPService } from "./../../services/httpService";

const API = new HTTPService();

class navTopBar extends Component {
  state = {
    menu: false,
    namePage: "Requestimates",
    selectedRequestimate: {},
    myWorkCount: 0
  };

  setNamePage = (namePage) => {
    this.setState({ namePage });
    this.setState({ menu: false });
  };

  openMenu = async () => {
    this.setState({ menu: true });
  };

  closeMenu = async () => {
    this.setState({ menu: false });
  };

  doSubmit = async () => {
    Auth.signOut()
      .then(() => {
        localStorage.clear();
        this.props.history.push("/login");
      })
      .catch((err) => {
        //console.log(err);
      });
  };

  handleCancel = () => {
    this.setState({ selectedRequestimate: {} });
  };

  async componentDidMount() {
    // Load technician's assigned work count
    if (this.isTechnician()) {
      await this.loadMyWorkCount();
    }
  }

  // Check if current user is a technician
  isTechnician = () => {
    const user = JSON.parse(localStorage.getItem("userAPI"));
    return this.props.userType === "installer" && user?.role === "technician";
  };

  // Load count of services assigned to technician
  loadMyWorkCount = async () => {
    try {
      const response = await API.get(`/requestService/technician/${this.props.userId}`);
      if (response.data && Array.isArray(response.data)) {
        // Count services that are not finished
        const activeServices = response.data.filter(s => s.service_state !== 'finished');
        this.setState({ myWorkCount: activeServices.length });
      }
    } catch (error) {
      console.error('Error loading My Work count:', error);
    }
  };

  render() {
    var imageName = require("./../../assets/Jobvious_white_logo_base.svg");

    const selectorProps = {
      companyName: this.props.title,
      userId: this.props.userId,
      userType: this.props.userType,
      userRole: this.props.userRole,
      locations: this.props.locations,
      selectedLocationId: this.props.selectedLocationId,
      onSwitch: this.props.onSwitch,
      onLocationChange: this.props.onLocationChange,
      selectedDealerId: this.props.selectedDealerId,
      groupId: this.props.groupId,
    };

    if (this.state.menu) {
      return (
        <React.Fragment>
          <Navbar
            onToggle={this.closeMenu}
            expanded={true}
            bg="dark"
            variant="dark"
            expand="lg"
            className="bg-menu shadow-sm mb-2"
          >
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <div className="navbar-brand">
              <img
                src={imageName}
                alt=""
                height="40"
                className="d-inline-block align-top mt--2"
              />
            </div>

            <Navbar.Collapse id="basic-navbar-nav" className="pt-5">
              {/* Unified Company/Location Selector */}
              <div className="mb-3">
                <CompanyLocationSelector
                  {...selectorProps}
                  variant="mobile-expanded"
                  onAfterSelect={() => this.setState({ menu: false })}
                />
              </div>

              <Nav className="mr-auto">
                {/* Technician-specific navigation */}
                {this.isTechnician() ? (
                  <>
                    {/* My Work - Primary view for technicians */}
                    <li>
                      <NavLink
                        activeClassName="active"
                        onClick={() => this.setNamePage("My Work")}
                        className="text-light"
                        to="/mywork"
                      >
                        {this.state.myWorkCount > 0 && (
                          <Badge pill variant="danger" className="mr-1">
                            {this.state.myWorkCount}
                          </Badge>
                        )}
                        <i className="fa-sharp fa-regular fa-tasks" aria-hidden="true"></i>{" "}
                        My Work
                      </NavLink>
                    </li>

                    {/* My Time - only if time tracking is enabled */}
                    {(() => {
                      const companyData = JSON.parse(localStorage.getItem('companyAPI') || '{}');
                      return (companyData.time_tracking_mode || 'none') !== 'none';
                    })() && (
                      <li>
                        <NavLink
                          activeClassName="active"
                          onClick={() => this.setNamePage("My Time")}
                          className="text-light"
                          to="/mytime"
                        >
                          <i className="fa-sharp fa-regular fa-stopwatch" aria-hidden="true"></i>{" "}
                          My Time
                        </NavLink>
                      </li>
                    )}

                    {/* Pickup/Deliver */}
                    <li>
                      <NavLink
                        activeClassName="active"
                        onClick={() => this.setNamePage("Pickups")}
                        className="text-light"
                        to="/pickups"
                      >
                        <i className="fa-sharp fa-regular fa-truck" aria-hidden="true"></i>{" "}
                        Pickup/Deliver
                      </NavLink>
                    </li>

                    {/* Leads */}
                    <li>
                      <NavLink
                        activeClassName="active"
                        onClick={() => this.setNamePage("Leads")}
                        className="text-light"
                        to="/referrals"
                      >
                        <i className="fa-sharp fa-regular fa-envelope" aria-hidden="true"></i>{" "}
                        Leads
                      </NavLink>
                    </li>
                  </>
                ) : (
                  <>
                    {/* Standard navigation for non-technicians */}
                    {(this.props.userType === "dealer" || this.props.userType === "installer") && (
                      <li>
                        <NavLink
                          activeClassName="active"
                          onClick={() => this.setNamePage(this.props.userType === "installer" ? "Leads" : "Referrals")}
                          className="text-light"
                          to="/referrals"
                        >
                          <i className="fa-sharp fa-regular fa-envelope" aria-hidden="true"></i>{" "}
                          {this.props.userType === "installer" ? "Leads" : "Referrals"}
                        </NavLink>
                      </li>
                    )}
                    <li>
                      <NavLink
                        activeClassName="active"
                        onClick={() => this.setNamePage("Requestimates")}
                        className="text-light"
                        to="/requestimates"
                      >
                        <i className="fa-sharp fa-regular fa-envelope" aria-hidden="true"></i>{" "}
                        Requestimates
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        activeClassName="active"
                        onClick={() => this.setNamePage("Jobs")}
                        className="text-light"
                        to="/jobs"
                      >
                        <i className="fa-sharp fa-regular fa-bar-chart" aria-hidden="true"></i> Jobs
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        activeClassName="active"
                        onClick={() => this.setNamePage("Pickups")}
                        className="text-light"
                        to="/pickups"
                      >
                        <i className="fa-sharp fa-regular fa-bar-chart" aria-hidden="true"></i>{" "}
                        Pickups
                      </NavLink>
                    </li>
                    {this.props.userType === "installer" && (
                      <li>
                        <NavLink
                          activeClassName="active"
                          onClick={() => this.setNamePage("Calendar")}
                          className="text-light"
                          to="/calendar"
                        >
                          <i className="fa-sharp fa-regular fa-calendar" aria-hidden="true"></i>{" "}
                          Calendar
                        </NavLink>
                      </li>
                    )}
                    {this.props.userType === "installer" && (
                      <li>
                        <NavLink
                          activeClassName="active"
                          onClick={() => this.setNamePage("Customers")}
                          className="text-light"
                          to="/customers"
                        >
                          <i className="fa-sharp fa-regular fa-users" aria-hidden="true"></i>{" "}
                          Customers
                        </NavLink>
                      </li>
                    )}
                    {this.props.userType === "installer" && (
                      <li>
                        <NavLink
                          activeClassName="active"
                          onClick={() => this.setNamePage("Inventory")}
                          className="text-light"
                          to="/inventory"
                        >
                          <i className="fa-sharp fa-regular fa-cubes" aria-hidden="true"></i>{" "}
                          Inventory
                        </NavLink>
                      </li>
                    )}
                  </>
                )}
              </Nav>

              <div className="text-center mt-5">
                <button
                  className="btn btn-link text-white"
                  onClick={this.doSubmit}
                >
                  SIGN OUT
                </button>
              </div>
            </Navbar.Collapse>
          </Navbar>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className="pos-f-t text-center">
            <nav className="navbar navbar-light bg-light text-center">
              <button
                className="navbar-toggler"
                type="button"
                onClick={this.openMenu}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              {/* Unified Company/Location Selector - collapsed bar */}
              <span className="navbar-brand">
                <CompanyLocationSelector
                  {...selectorProps}
                  variant="mobile-collapsed"
                />
              </span>
            </nav>
          </div>
        </React.Fragment>
      );
    }
  }
}

export default withRouter(navTopBar);
